import request from '@/utils/request'

export function applyTask(traderId) {
  return request({
    url: '/aq/apply-task',
    method: 'post',
    params: {
      traderId: traderId
    }
  })
}

export function queryTask(traderId) {
  return request({
    url: '/aq/query-task',
    method: 'post',
    params: {
      traderId: traderId
    }
  })
}

// 上传图片接口
export function uploadImage(file) {
  const formData = new FormData()
  formData.append('file', file)

  return request({
    url: '/aq/upload-image',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 提交订单接口
export function submitOrder(orderId, name, imageUrl) {
  return request({
    url: '/aq/submit-order',
    method: 'post',
    params: {
      orderId: orderId,
      name: name,
      imageUrl: imageUrl
    }
  })
}

// 订单列表接口
export function orderList(params) {
  return request({
    url: '/aq/order-list',
    method: 'post',
    params: params
  })
}
